// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable selector-class-pattern */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  width: 100%;
}

mat-progress-bar {
  position: absolute;
}

spx-dialog-action:not(:last-child) {
  padding-right: 4px;
}

spx-dialog-action:not(:first-child) {
  padding-left: 4px;
}

.dialog__title {
  padding: 12px 24px;
}
.dialog__title spx-icon {
  margin-left: 12px;
}

.mdc-dialog__title,
.mdc-dialog__content {
  padding: 0;
}

.mdc-dialog__actions {
  padding: 12px 22px;
}

.dialog__content {
  height: 100%;
  padding: 0 24px;
}

.dialog__content.no-padding-content {
  padding: 0;
}

.floating-close-button {
  right: 16px;
  position: absolute;
  top: 16px;
  z-index: 1;
}

.dialog__content__container {
  padding: 12px 0;
}

/* stylelint-enable selector-class-pattern */
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImRpYWxvZy5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSw2Q0FBQTtBQUNBO0VBQ0UsYUFBQTtFQUNBLHNCQUFBO0VBQ0EsWUFBQTtFQUNBLGtCQUFBO0VBQ0EsV0FBQTtBQUNGOztBQUVBO0VBQ0Usa0JBQUE7QUFDRjs7QUFFQTtFQUNFLGtCQUFBO0FBQ0Y7O0FBRUE7RUFDRSxpQkFBQTtBQUNGOztBQUVBO0VBQ0Usa0JBQUE7QUFDRjtBQUNFO0VBQ0UsaUJBQUE7QUFDSjs7QUFHQTs7RUFFRSxVQUFBO0FBQUY7O0FBR0E7RUFDRSxrQkFBQTtBQUFGOztBQUdBO0VBQ0UsWUFBQTtFQUNBLGVBQUE7QUFBRjs7QUFHQTtFQUNFLFVBQUE7QUFBRjs7QUFHQTtFQUNFLFdBQUE7RUFDQSxrQkFBQTtFQUNBLFNBQUE7RUFDQSxVQUFBO0FBQUY7O0FBR0E7RUFDRSxlQUFBO0FBQUY7O0FBRUEsNENBQUEiLCJmaWxlIjoiZGlhbG9nLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLyogc3R5bGVsaW50LWRpc2FibGUgc2VsZWN0b3ItY2xhc3MtcGF0dGVybiAqL1xuOmhvc3Qge1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBoZWlnaHQ6IDEwMCU7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgd2lkdGg6IDEwMCU7XG59XG5cbm1hdC1wcm9ncmVzcy1iYXIge1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG59XG5cbnNweC1kaWFsb2ctYWN0aW9uOm5vdCg6bGFzdC1jaGlsZCkge1xuICBwYWRkaW5nLXJpZ2h0OiA0cHg7XG59XG5cbnNweC1kaWFsb2ctYWN0aW9uOm5vdCg6Zmlyc3QtY2hpbGQpIHtcbiAgcGFkZGluZy1sZWZ0OiA0cHg7XG59XG5cbi5kaWFsb2dfX3RpdGxlIHtcbiAgcGFkZGluZzogMTJweCAyNHB4O1xuXG4gIHNweC1pY29uIHtcbiAgICBtYXJnaW4tbGVmdDogMTJweDtcbiAgfVxufVxuXG4ubWRjLWRpYWxvZ19fdGl0bGUsXG4ubWRjLWRpYWxvZ19fY29udGVudCB7XG4gIHBhZGRpbmc6IDA7XG59XG5cbi5tZGMtZGlhbG9nX19hY3Rpb25zIHtcbiAgcGFkZGluZzogMTJweCAyMnB4O1xufVxuXG4uZGlhbG9nX19jb250ZW50IHtcbiAgaGVpZ2h0OiAxMDAlO1xuICBwYWRkaW5nOiAwIDI0cHg7XG59XG5cbi5kaWFsb2dfX2NvbnRlbnQubm8tcGFkZGluZy1jb250ZW50IHtcbiAgcGFkZGluZzogMDtcbn1cblxuLmZsb2F0aW5nLWNsb3NlLWJ1dHRvbiB7XG4gIHJpZ2h0OiAxNnB4O1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHRvcDogMTZweDtcbiAgei1pbmRleDogMTtcbn1cblxuLmRpYWxvZ19fY29udGVudF9fY29udGFpbmVyIHtcbiAgcGFkZGluZzogMTJweCAwO1xufVxuLyogc3R5bGVsaW50LWVuYWJsZSBzZWxlY3Rvci1jbGFzcy1wYXR0ZXJuICovXG4iXX0= */`, "",{"version":3,"sources":["webpack://./libs/shared/ng/base/src/lib/dialog/components/dialog/dialog.component.scss"],"names":[],"mappings":"AAAA,6CAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,kBAAA;AACF;AACE;EACE,iBAAA;AACJ;;AAGA;;EAEE,UAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,YAAA;EACA,eAAA;AAAF;;AAGA;EACE,UAAA;AAAF;;AAGA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAEA,4CAAA;AACA,40DAA40D","sourcesContent":["/* stylelint-disable selector-class-pattern */\n:host {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  position: relative;\n  width: 100%;\n}\n\nmat-progress-bar {\n  position: absolute;\n}\n\nspx-dialog-action:not(:last-child) {\n  padding-right: 4px;\n}\n\nspx-dialog-action:not(:first-child) {\n  padding-left: 4px;\n}\n\n.dialog__title {\n  padding: 12px 24px;\n\n  spx-icon {\n    margin-left: 12px;\n  }\n}\n\n.mdc-dialog__title,\n.mdc-dialog__content {\n  padding: 0;\n}\n\n.mdc-dialog__actions {\n  padding: 12px 22px;\n}\n\n.dialog__content {\n  height: 100%;\n  padding: 0 24px;\n}\n\n.dialog__content.no-padding-content {\n  padding: 0;\n}\n\n.floating-close-button {\n  right: 16px;\n  position: absolute;\n  top: 16px;\n  z-index: 1;\n}\n\n.dialog__content__container {\n  padding: 12px 0;\n}\n/* stylelint-enable selector-class-pattern */\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
